<template>
    <div>
        <mu-snackbar position="top" :open="$store.state.notify.open" :color="$store.state.notify.color">
            {{$store.state.notify.message}}
            <mu-button small slot="action" color="orange800" v-if="$store.state.notify.paymentAuditLinkVisible" @click="toPaymentAuditPage">立即审核</mu-button>
            <mu-button flat slot="action" color="grey50" @click="$store.dispatch('notify/hideMessage')">关闭</mu-button>
        </mu-snackbar>

        <router-view></router-view>

        <mu-dialog 
            width="90%" max-width="300" 
            :open="$store.state.user.versionExpired"
            :overlay-close="false"
            :overlay-opacity="0.6">
            
            <h4>系统版本已更新，需要刷新页面</h4>

            <mu-button slot="actions" flat color="primary" @click="refresh">立即刷新</mu-button>
        </mu-dialog>
    </div>
</template>

<script>
import wechatUtil from './utils/wechatUtil';

export default {
    components: {
    },
    mounted() {
        wechatUtil.init();
    },
    data() {
        return {
            
        }
    },
    computed: {
            
        },
    methods: {
        refresh() {
            window.location.reload();
        },
        toPaymentAuditPage() {
            this.$store.dispatch('notify/hideMessage');
            this.$router.push({path: '/ops/finance/paymentAuditCheck'});
        }
    }
};
</script>

<style lang="scss">
.mu-paper {
    padding: 0px 10px;
}

.mu-table th, .mu-table td {
    
    padding-left: 2px !important;
    padding-right: 2px !important;

}

.mu-table tr.is-stripe {
    td {
        background-color: #f5f5f5;
    }
}

.mu-table tr.is-hover {
    td {
        background-color: #bbdefb;
    }
}

tr.expand-row {

    td.mu-checkbox-col {
        background-color: #eceff1 !important;
        border-top: 2px solid #1e88e5;
    }
}

.scroll-container {
    overflow: auto;

    &::-webkit-scrollbar {
        width: 9px;
        height: 9px;
        border-radius: 8px;
        // display: block;
    }
    &::-webkit-scrollbar-track {
        background: #eee;
        // background: rgba(0, 0, 0, .33);
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background: #aaa;
        background: rgba(0, 0, 0, 0.2);
        &:hover {
            background: #666;
            background: rgba(0, 0, 0, .4);
        }
    }
    &::-webkit-scrollbar-button {
        cursor: pointer;
        background: #eee;
        // display: none;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 4px;
    }
}


/* 滚动条 end */


/* 主容器 start */

.main-container {
    display: flex;
    background: white;
    min-height: 100%;

    &.width-full {
        width: 100%;
    }
    &.full {
        width: 100%;
        height: 100%;
    }
}
.main-wraper {
    &.width-full {
        width: 100%;
    }
    &.full {
        width: 100%;
        height: 100%;
    }
}

/* 主容器 end */


/* 左侧栏 start */

.sidebar {
    position: fixed;
    left: 0px;
    right: 0px;
    top: 0px;
    height: 50px;
    line-height: 50px;
    width: 100%;
    transition: all .3s ease;
    z-index: 999;
    background: #fff;
    color: #000;
    border-bottom: 1px solid #6a82ec;
}

.inner {
    display: flex;
    width: 980px;
    margin: 0 auto;
}
/* 导航栏 start */

.main-wraper {
    margin: 0 auto;
    padding-top: 40px;
    position: relative;
    box-sizing: border-box;
    display: flex;
    background: white;
    flex: 1 1 auto;
    flex-direction: column;
    transition: all .3s ease;
}

.view {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    padding: 20px 20px 10px 20px;
}

.view-title {
    flex-shrink: 0;
    margin: 10px 0px 30px;
    padding-left: 10px;
    border-left: 4px solid #eee;
    position: relative;
    font-size: 16px;
}
.code {
    background: #fff;
    margin-bottom: 20px;
}


.fixed-table {
    width: 100%;
}

.border {
    border: 1px solid #dadada;
    border-top: none;
}

// .el-table .cell {
//     line-height: 42px;
// }
</style>




// WEBPACK FOOTER //
// src/App.vue